// 画面で使うブランド値。
//
// ビルド時に確定する（環境ごとに別ビルド・別デプロイのため）。
// 実行時に API から取りに行く形にすると、初回描画でブランド名が一瞬出ない・
// 毎ページ 1 往復増える、という副作用があるので採らない。
//
// 値の追加は `src/shared/brand.ts` の Brand に足してから、ここに 1 行足す。
import { resolveBrand, type Brand } from "../../shared/brand";

export const brand: Brand = resolveBrand(
  {
    shortName: import.meta.env.VITE_BRAND_SHORT_NAME,
    name: import.meta.env.VITE_BRAND_NAME,
    companyName: import.meta.env.VITE_BRAND_COMPANY_NAME,
    siteName: import.meta.env.VITE_BRAND_SITE_NAME,
    description: import.meta.env.VITE_BRAND_DESCRIPTION,
    lineAccountName: import.meta.env.VITE_BRAND_LINE_ACCOUNT_NAME,
    supportEmail: import.meta.env.VITE_BRAND_SUPPORT_EMAIL,
  },
  import.meta.env.VITE_BRAND_ID,
);

/**
 * 略称の横に正式名称も並べるか。
 *
 * 「CFL / CloseFamilyLounge」のように略称と正式名称が違うブランドでは 2 つ並べる。
 * 「オフレコ」のように同じブランドで並べると「オフレコ オフレコ」になるので、
 * その場合は略称だけを出す。
 */
export const showFullName = brand.shortName !== brand.name;
